export class EmployeeSearchDataModel {
    constructor() {
        this.columnFilters = [];
    }
}
export default class EmployeeSearchData extends EmployeeSearchDataModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
